import { type AxiosError, isAxiosError } from "axios";

const INSUFFICIENT_ROLES_ERROR = "insufficient_role_permissions";
const INSUFFICIENT_LOCATIONS_ERROR = "insufficient_location_permissions";

export const isAuthorizationError = (error: unknown): error is AxiosError<{ value: string }> => {
  return (
    isAxiosError(error) &&
    error.response?.status === 401 &&
    (error.response.data.error === INSUFFICIENT_ROLES_ERROR ||
      error.response.data === INSUFFICIENT_LOCATIONS_ERROR)
  );
};
